export const rosterPriceSheet: Record<string, number> = {
  '1SB': 0,
  '1SS': 50,
  '1SG': 150,
  '2SB': 300,
  '2SS': 500,
  '2SG': 800,
  '3SB': 1400,
  '3SS': 2100,
  '3SG': 3000,
  '4SB': 5000,
  '4SS': 7500,
  '4SG': 10500,
  '5SB': 15500,
  '5SS': 22500,
  '5SG': 40000,
  '6SB': 95000,
  '6SS': 165000,
  '6SG': 365000,
};

export const SECTION_IDS = {
  mission: 'section-mission',
  fuseUp: 'section-fuse-up',
  recruitment: 'section-recruitment',
  items: 'section-items',
} as const;
